import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Offcanvas, Button } from "react-bootstrap";

function Header({ searchQuery, handleSearchChange, isLoggedIn }) {
  const location = useLocation();
  const [showTopOffcanvas, setShowTopOffcanvas] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const shouldBeSticky =
        ["/", "/umrlice", "/poslednji-pozdravi", "/pomeni"].includes(
          location.pathname
        ) && window.scrollY > 0;

      setIsSticky(shouldBeSticky);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  return (
    <header className={`header ${isSticky ? "sticky" : ""}`}>
      <Container style={{ padding: "0" }}>
        <div
          className="top-header"
          style={{
            display: "flex",
            paddingTop: "10px",
            marginBottom: "5px",
          }}
        >
          <a
            style={{
              textDecoration: "none",
              color: "black",
              display: "flex",
              alignItems: "center",
              paddingRight: "10px",
            }}
            href="www.nowwhere.com"
          >
            Kontakt informacije
          </a>
          {" | "}
          <a
            style={{
              textDecoration: "none",
              color: "black",
              display: "flex",
              alignItems: "center",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
            href="www.nowwhere.com"
          >
            Cjenovnik
          </a>{" "}
          {" | "}
          <a
            style={{
              textDecoration: "none",
              color: "black",
              display: "flex",
              alignItems: "center",
              paddingLeft: "5px",
            }}
            href="/tutorial"
          >
            Uputstvo za korišćenje
          </a>
        </div>
        <Offcanvas
          style={{ height: "80px" }}
          show={showTopOffcanvas}
          onHide={() => setShowTopOffcanvas(false)}
          placement="top"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Body>
              {" "}
              <input
                style={{
                  border: "1px solid white",
                  outline: "none",
                  width: "100%",
                  color: "black",
                }}
                type="text"
                name="search"
                className="offCanvas-search"
                placeholder="Pretraži..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </Offcanvas.Body>
          </Offcanvas.Header>
        </Offcanvas>
        <Offcanvas
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Meni</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav.Link
              href="/home"
              className={location.pathname === "/" ? "active-page" : ""}
            >
              Početna
            </Nav.Link>
            <Nav.Link
              href="/umrlice"
              className={location.pathname === "/umrlice" ? "active-page" : ""}
            >
              Umrlice
            </Nav.Link>
            <Nav.Link
              href="/poslednji-pozdravi"
              className={
                location.pathname === "/poslednji-pozdravi" ? "active-page" : ""
              }
            >
              Poslednji pozdravi
            </Nav.Link>
            <Nav.Link
              href="/pomeni"
              className={location.pathname === "/pomeni" ? "active-page" : ""}
            >
              Pomeni
            </Nav.Link>
            <Nav.Link
              href="/predaj-citulju"
              className={
                location.pathname === "/predaj-citulju" ? "active-page" : ""
              }
            >
              Predaj čitulju
            </Nav.Link>
            {!isLoggedIn && (
              <Nav.Link
                href="/login"
                className={location.pathname === "/login" ? "active-page" : ""}
              >
                Uloguj se
              </Nav.Link>
            )}
            {!isLoggedIn && (
              <Nav.Link
                href="/register"
                className={
                  location.pathname === "/register" ? "active-page" : ""
                }
              >
                Registruj se
              </Nav.Link>
            )}

            <input
              style={{
                border: "none",
              }}
              type="text"
              className="search-click-lg"
              name="search"
              placeholder="Pretraži..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {isLoggedIn && (
              <Nav.Link
                href="/user-profile"
                className={
                  location.pathname === "/user-profile" ? "active-page" : ""
                }
              >
                Moj profil
              </Nav.Link>
            )}
          </Offcanvas.Body>
        </Offcanvas>

        <Navbar
          bg="white"
          expand="lg"
          className="d-flex align-items-center nav-menu"
        >
          <img
            onClick={() => setShowTopOffcanvas(!showTopOffcanvas)}
            height={30}
            className="small-nav-img"
            src={require("../assets/search.png")}
            alt="search-icon"
            style={{ marginLeft: "20px", display: "none" }}
          />{" "}
          <img
            className="logo"
            height={50}
            src={require("../assets/vijesti-logo.png")}
            alt="logo"
          />
          <Navbar.Toggle onClick={() => setShowOffcanvas(!showOffcanvas)} />
          <Nav style={{ fontWeight: "bold" }} className="ms-auto lg-nav">
            <Nav.Link
              href="/home"
              className={location.pathname === "/" ? "active-page" : ""}
            >
              Početna
            </Nav.Link>
            <Nav.Link
              href="/umrlice"
              className={location.pathname === "/umrlice" ? "active-page" : ""}
            >
              Umrlice
            </Nav.Link>
            <Nav.Link
              href="/poslednji-pozdravi"
              className={
                location.pathname === "/poslednji-pozdravi" ? "active-page" : ""
              }
            >
              Poslednji pozdravi
            </Nav.Link>
            <Nav.Link
              href="/pomeni"
              className={location.pathname === "/pomeni" ? "active-page" : ""}
            >
              Pomeni
            </Nav.Link>
            <Nav.Link
              href="/predaj-citulju"
              className={
                location.pathname === "/predaj-citulju" ? "active-page" : ""
              }
            >
              Predaj čitulju
            </Nav.Link>
            {!isLoggedIn && (
              <Nav.Link
                href="/login"
                className={location.pathname === "/login" ? "active-page" : ""}
              >
                Uloguj se
              </Nav.Link>
            )}
            {!isLoggedIn && (
              <Nav.Link
                href="/register"
                className={
                  location.pathname === "/register" ? "active-page" : ""
                }
              >
                Registruj se
              </Nav.Link>
            )}

            <input
              style={{
                border: "none",
              }}
              type="text"
              className="search-click-lg"
              name="search"
              placeholder="Pretraži..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {isLoggedIn && (
              <Nav.Link
                href="/user-profile"
                className={
                  location.pathname === "/user-profile" ? "active-page" : ""
                }
              >
                <img
                  className="profile-icon"
                  alt="profile-icon"
                  height={20}
                  src={require("../assets/user-updated.png")}
                />
              </Nav.Link>
            )}
          </Nav>
        </Navbar>
      </Container>
    </header>
  );
}

export default Header;
